import { TemplateConfig } from '../types';

export const jobHuntSpreadConfig: TemplateConfig = {
  id: 'job-hunt-spread',
  name: '寻工作牌阵',
  description: '分析求职现状、适合方向、阻碍与发展',
  cardCount: 5,
  
  fieldDefaults: {
    title: '寻工作牌阵',
    customerQuestion: '分析现在去找工作的情况，看到你适合做什么工作，阻碍和发展怎么样。',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌'
    ],
    cardInfos: [
      '现在去找工作怎么样',
      '适合做什么样的工作',
      '有什么样的阻碍',
      '工作发展怎么样',
      '最终结果'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1677ff',
    backgroundColor: '#e6f4ff',
    icon: '💼'
  }
};
